// Mirrors SIGNATURE_BOX_RATIO in functions/src/documents/stamp.ts
export const SIGNATURE_BOX_RATIO = 3;
export const DOCUMENT_STATUS_TITLES = {
    signed_by_instructor: 'Podepsáno instruktorem',
    signed: 'Podepsáno oběma stranami',
    declined: 'Odmítnuto',
    invalidated: 'Zneplatněno',
};
